import { apiSlice } from '../../app/api/apiSlice'
import { urlConfig } from '../../config'

export interface Message {
  _id: string
  message: string
  user: string
  isAdmin: string
  createdAt: string
}

const chatApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getMessages: builder.mutation({
      query: ({ page = 1, limit = 1000 }) =>
        `${urlConfig.chatsBaseUrl}/chats/messages?limit=${limit}`,
    }),
    currentUser: builder.query<any, { time?: number } | void>({
      query: (params) => ({
        url: `${urlConfig.authBaseUrl}/auth/users/current${params?.time ? `?_t=${params.time}` : ''}`,
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useGetMessagesMutation,
  useLazyCurrentUserQuery,
  useCurrentUserQuery,
} = chatApiSlice
